import { 
  MAIN_GET_COMMON_DATA, 
  PENDING, FULFILLED, REJECTED,
} from '../globals';

const defaultAgreement = 'Souhlasím se zpracováním osobních údajů.';

export const initialState = {
  isLoading: false,
  status: false,
  error: false,
  data: {
    previousSteps: {
      one: '',
      two: '',
      three: '',
    },
    officesCommon: {
      content: '',
      title: '',
    },
    servicesCommon: {
      content: '',
      title: '',
    },
    intervalsCommon: {
      content: '',
      showStats: false,
      title: '',
    },
    reservationCommon: {
      content: '',
      name: {
        show: true,
        isRequired: true,
      },
      phone: {
        show: true,
        isRequired: true,
      },
      agreement: {
        show: true,
        text: defaultAgreement,
        document: null,
      },
      note: {
        show: false,
        isRequired: false,
      },
    },
    logo: {
      fileName: '',
    },
  },
  errorMessage: [],
};

const reducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case `${MAIN_GET_COMMON_DATA}_${PENDING}`:
      return {
        ...initialState,
        isLoading: true,
      };

    case `${MAIN_GET_COMMON_DATA}_${FULFILLED}`:
      return {
        ...state,
        isLoading: false,
        status: payload.status,
        data: {
          ...state.data,
          previousSteps: {
            one: payload.data.step_one_selected === '' ? 'Vybrané místo:' : payload.data.step_one_selected,
            two: payload.data.step_two_selected === '' ? 'Vybraná služba:' : payload.data.step_two_selected,
            three: payload.data.step_three_selected === '' ? 'Vybraný termín:' : payload.data.step_three_selected,
          },
          officesCommon: {
            content: payload.data.step_one,
            title: payload.data.step_one_title === '' ? 'Výběr místa' : payload.data.step_one_title,
          },
          servicesCommon: {
            content: payload.data.step_two,
            title: payload.data.step_two_title === '' ? 'Výběr služby' : payload.data.step_two_title,
          },
          intervalsCommon: {
            content: payload.data.step_three,
            title: payload.data.step_three_title === '' ? 'Výběr termínu' : payload.data.step_three_title,
            showStats: payload.data.show_stats,
          },
          reservationCommon: {
            content: payload.data.step_four,
            title: payload.data.step_four_title === '' ? 'Potvrzení rezervace' : payload.data.step_four_title,
            name: {
              show: payload.data.form_name,
              isRequired: payload.data.form_name_required,
            },
            phone: {
              show: payload.data.form_phone,
              isRequired: payload.data.form_phone_required,
            },
            agreement: {
              show: payload.data.form_checkbox,
              text: payload.data.step_four_conditions === '' ? defaultAgreement : payload.data.step_four_conditions,
              document: (payload.data.document !== null && payload.data.document.hasOwnProperty('file_name')) ? payload.data.document.file_name : null,
            },
            note: {
              show: payload.data.form_note,
              isRequired: payload.data.form_note_required,
            },
          },
          logo: {
            ...state.data.logo,
            fileName: (payload.data.logo !== null && payload.data.logo.hasOwnProperty('file_name')) ? payload.data.logo.file_name : '',
          },
        },
      };

    case `${MAIN_GET_COMMON_DATA}_${REJECTED}`: 
      return {
        ...state,
        isLoading: false,
        status: false,
        error: true,
        errorMessage: payload.error,
      };
    
    default:
      return state;
  }
};

export default reducer;


// WEBPACK FOOTER //
// ./src/reducers/main.js